import { generatePath, Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

import { PageUrlKey } from '@/entities/page-url-key';
import { useCurrentAsset } from '@/hooks/use-current-asset';

/**
 * Empty state shown when the current site doesn't have PCS data.
 * Guides users to navigate to a different page.
 */
export function NoPcsDataState() {
  const { assetId } = useCurrentAsset();

  const overviewPath = generatePath('/asset/:siteId/:page', {
    siteId: assetId ?? '',
    page: PageUrlKey.OVERVIEW,
  });

  const dataExplorerPath = generatePath('/asset/:siteId/:page', {
    siteId: assetId ?? '',
    page: PageUrlKey.DATA_EXPLORER,
  });

  return (
    <div
      className="mx-auto mt-12 max-w-lg rounded-lg border border-amber-200 bg-amber-50 p-8 text-center"
      data-testid="no-pcs-data-state"
    >
      <ExclamationTriangleIcon className="mx-auto mb-4 size-12 text-amber-500" />

      <h2 className="mb-2 text-lg font-semibold text-amber-900">
        No PCS data available for this site
      </h2>

      <p className="mb-6 text-sm text-amber-800">
        This site doesn't have Power Conversion System (PCS) data. PCS
        monitoring may not be configured for this location, or the site may not
        have PCS equipment installed.
      </p>

      <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
        <Link
          to={overviewPath}
          className="inline-flex items-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          Go to Overview
        </Link>
        <Link
          to={dataExplorerPath}
          className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          Open Data Explorer
        </Link>
      </div>
    </div>
  );
}
